import script from "./PerfilPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilPage.vue?vue&type=script&setup=true&lang=js"

import "./PerfilPage.vue?vue&type=style&index=0&id=50f196a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f196a2"]])

export default __exports__